import {
  AppText,
  Button,
  CustomContainer,
  FlexColumn,
  GridContainer,
} from "src/style";
import Info from "src/assets/svg/cbp-info";
import Approved from "src/assets/svg/cbp-approved";
import Rejected from "src/assets/svg/cbp-rejected";
import Lottie from "lottie-react";
import successGif from "src/assets/gif/success.json";
import { useGetCbpProfile } from "src/hooks/cbp/useGetCbpProfile";
import { useContext, useEffect, useState } from "react";
import AppInfoContext from "src/provider/state-manager/appInfoProvider";
import { useNavigate } from "react-router-dom";

interface ScreeningProps {
  onNext: () => void;
}
const CbpScreening = ({ onNext }: ScreeningProps) => {
  const { data: cbpProfile } = useGetCbpProfile();
  const { setInfoProperty } = useContext(AppInfoContext);
  const navigate = useNavigate();

  const [screening, setScreening] = useState(false);
  const [approved, setApproved] = useState(false);
  const [rejected, setRejected] = useState(false);

  useEffect(() => {
    if (
      cbpProfile?.status === "IndemnityRejected" ||
      cbpProfile?.status === "AmlScreeningFailed"
    ) {
      setRejected(true);
    } else if (
      cbpProfile?.status === "Approved" ||
      cbpProfile?.status === "AmlScreeningPassed"
    ) {
      setApproved(true);
    } else {
      setScreening(true);
    }
  }, []);

  return (
    <CustomContainer className="cbp-container">
      {screening && (
        <>
          <AppText
            textSize="2.2"
            fontWeight="700"
            color="#000000"
            align="center"
            bottomMargin="1.5"
            topMargin="5"
          >
            {"We are currently reviewing your account"}
          </AppText>

          <FlexColumn justifyContent="center" topMargin="5">
            <Info />
            <AppText
              textSize="1.8"
              fontWeight="300"
              color="#000000"
              align="center"
              bottomMargin="1.5"
              topMargin="3"
            >
              We are reviewing your account. You don’t have to do anything. Once
              everything checks you’ll get a notification.
            </AppText>
          </FlexColumn>
        </>
      )}

      {approved && (
        <>
          <AppText
            textSize="2.2"
            fontWeight="700"
            color="#000000"
            align="center"
            topMargin="5"
          >
            {"Screening Successful"}
          </AppText>

          <FlexColumn justifyContent="center">
            {/* <Approved /> */}
            {/* <AppText
              textSize="1.8"
              fontWeight="300"
              color="#000000"
              align="center"
              bottomMargin="1.5"
              topMargin="3"
            >
              Your account is now successfully created.
            </AppText> */}
          </FlexColumn>
          <FlexColumn justifyContent="center">
            <GridContainer width="20" sizeUnit="">
              <Lottie animationData={successGif} loop={true} />
            </GridContainer>
            <AppText
              textSize="2.2"
              fontWeight="700"
              fontFamily="Gilmer-Bold"
              align="center"
            >
              Account Created Successfully
            </AppText>
            <FlexColumn
              bgColor="#F9FAFB"
              height="30"
              justifyContent="flex-center"
              alignItems="flex-start"
              padding="3"
              radius="2"
            >
              <AppText fontWeight="600" textSize="2">
                Account Details
              </AppText>
              <AppText
                fontWeight="40"
                textSize="2"
                topMargin="2"
                color="#667085"
              >
                Account Name
              </AppText>
              <AppText fontWeight="400" textSize="2">
                {cbpProfile?.fullName}
              </AppText>
              <AppText
                fontWeight="40"
                textSize="2"
                topMargin="2"
                color="#667085"
              >
                Account Number
              </AppText>
              <AppText fontWeight="600" textSize="2">
                {cbpProfile?.primaryAccountNumber}
              </AppText>
            </FlexColumn>
          </FlexColumn>
          <Button
            width="100%"
            height="4"
            borderColor="#0D968F"
            hoverBgColor="#fff"
            hoverColor="#0D968F"
            titleSize="1.4"
            topMargin="2.5"
            onClick={() => {
              navigate("/dashboard/cbp");
              setInfoProperty("cbp", true);
            }}
          >
            Proceed to Dashboard
          </Button>
        </>
      )}

      {rejected && (
        <>
          <AppText
            textSize="2.2"
            fontWeight="700"
            color="#000000"
            align="center"
            bottomMargin="1.5"
            topMargin="5"
          >
            {"Screening Unsuccessful"}
          </AppText>

          <FlexColumn justifyContent="center" topMargin="5">
            <Rejected />
            <AppText
              textSize="1.8"
              fontWeight="300"
              color="#000000"
              align="center"
              bottomMargin="1.5"
              topMargin="3"
            >
              We cannot proceed with this application
            </AppText>
          </FlexColumn>
        </>
      )}
    </CustomContainer>
  );
};

export default CbpScreening;
